import { useEffect, useState } from 'react';
import './AuthStatusIndicator.css'
interface AuthStatusIndicatorProps {
    status: 'success' | 'error';
}
export const AuthStatusIndicator = ({status}: AuthStatusIndicatorProps) => {
    const [show, setShow] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => setShow(true), 900);
        return () => clearTimeout(timer);
    }, []);
    const successElement = show ? (
        <div
            data-testid="status-indicator"
            className="status-indicator tick"
        />
    ) : null;
    const errorElement = show ? (
        <>
            <div data-testid="status-indicator-c1" className="status-indicator cross c1" />
            <div data-testid="status-indicator-c2" className="status-indicator cross c2" />
        </>
    ) : null;
    return (
        <>
            {status === 'error' ? errorElement: successElement}
        </>
    );
}